import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'
import http from 'utils/http'
import { endpoints } from 'global/endpoints'
import { toast } from 'react-toastify'
import { routePaths } from 'global/routePaths'

const postAdvertisement = (postData) => {
  const updatedEndpoints = endpoints.advertisement.base
  return http('multipart').post(updatedEndpoints, postData)
}

export function usePostAdvertisement() {
  const history = useHistory()

  return useMutation(postAdvertisement, {
    onSuccess: () => {
      toast.success('Advertisement has been added successfully!')
      history.push(routePaths.home.advertisement.base)
    },
    onError: (error) => {
      const message = error?.response?.data?.message
      toast.error(message)
    },
  })
}
